 <template>
  <div>
    <div class="wrapper-intro">
      <div class="container" style="background-color:rgba(0,0,0,0.2);padding-top:45px;padding-bottom:45px;border-right:1px solid rgba(0,0,0,0.2);border-left:1px solid rgba(0,0,0,0.2)">
        <div class="row justify-content-center" style="padding:15px 0px 15px 0px;">
          <div class="col-md-9 col-sm-12 text-center">
              <h1>Geofolio makes the world's environmental data accessible and understandable for everyone.</h1>
          </div>
        </div>
      </div>
    </div>


    <div class="wrapper-getstarted">
      <div class="container" style="padding-top:15px;padding-bottom:15px;background-color:rgba(0,0,0,0.02)">
        <div class="row  align-items-center" style="padding:15px 0px 15px 0px;">
          <div class="col-md-8 col-sm-12 text-left">
              <p>Define an area of interest anywhere in the world, and we'll automagically create thematic factsheets containing interactive maps, charts, written overviews, and statistical summaries – all based on open access geodata.</p>
          </div>
          <div class="col-md-4 col-sm-12 text-center">
            <!--
            <router-link :to="{ name: 'register' }"  class="btn btn-primary btn-try" style="padding-bottom:7px;">Create a free account</router-link>
            <br />-->

            <a href="" @click.prevent="createStart" class="btn btn-primary btn-try"><strong>Create a factsheet</strong></a>
            <br/>
            <a href="/f/540910687"><strong>Or see an example...</strong></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {
    }
  },
  components: {},
  name: 'Leader'
}
</script>

<style>
</style>

<style scoped>
    div.wrapper-intro {
      background-color:#111;
      background-image:url('/backgrounds/1.jpg');
      background-repeat: no-repeat;
      background-size:cover;
      background-position:center;
    }
    div.wrapper-intro h1 {
      color: #fff;
      text-shadow: 0 .1rem .15rem rgba(0, 0, 0, 1);
      line-height: 4rem;
      font-size:3em;
      text-align:center;
      font-weight:700;
      max-width:800px;
    }
    div.wrapper-getstarted {
      background-color:#f9f9f9;
      background-image:url('../../assets/geofolio-iso.svg');
      background-repeat: no-repeat;
      background-size:auto;
      background-position:center;
    }
    div.wrapper-getstarted p {
      font-size:1.4em;
      line-height:1.6em;
      color:#444;
      margin:0px;
    }
    .btn-try {
      border-radius:0px;
      font-size:1.4em;
      font-weight:600;
      margin-top:10px;
      margin-bottom:10px;
    }
</style>
